import { render, staticRenderFns } from "./expend.vue?vue&type=template&id=1edacb4c&scoped=true"
import script from "./expend.vue?vue&type=script&lang=js"
export * from "./expend.vue?vue&type=script&lang=js"
import style0 from "./expend.vue?vue&type=style&index=0&id=1edacb4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edacb4c",
  null
  
)

export default component.exports